import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Aroma = () => {

return (

<div>

<Navbar />
<Flexproducts type="aroma" />
<Header></Header>

</div>

);
};

export default Aroma;